module.exports = __webpack_public_path__ + "img/temperature.4a9eb58e.svg";